<template>
  <div
    v-if="showAdBanner"
    id="gtm_guide_banner"
    class="guide-banner"
    @click="goToLink"
  >
    <nuxt-img :src="adImage" />
  </div>
</template>

<script setup lang="ts">
const {
  public: { productUrl }
} = useRuntimeConfig()

const adBanner = {
  // 추후 API 연동
  showAdBanner: true,
  adImage: '/ads/kakao-insurance-ads.webp',
  adLink: productUrl + '/insurance'
}

const { showAdBanner, adImage, adLink } = adBanner

const goToLink = () => {
  // 외부 링크 열때
  // navigateTo(adLink, { external: true, open: { target: '_blank' } })

  // 내부 링크 열때
  navigateTo(adLink, { external: true })
}
</script>

<style lang="scss" scoped>
.guide-banner {
  width: 100%;
  margin-bottom: 8px;
  cursor: pointer;
  img {
    border-radius: 12px;
    width: 100%;
    object-fit: cover;
  }
}
</style>
